export default function zoomUtil () {
    // Если находимся на странице игры, не применяем zoom
    if (typeof window !== 'undefined' && window.location.pathname.startsWith("/game/")) {
        // Удаляем zoom, если он был установлен ранее
        if (document.body && document.body.style.zoom) {
            document.body.style.removeProperty('zoom');
        }
        // Выходим из функции - не применяем zoom для игр
        return;
    }
    
    const BASE_WIDTH = 1440; // Базовая ширина для которой не нужен зум
        //console.warn('devicePixelRatio:', window.devicePixelRatio);
        //console.warn('innerWidth:', window.innerWidth);
        //console.warn('any-pointer: fine:', window.matchMedia('(any-pointer: fine)').matches);
        //console.warn('Math.log2(window.devicePixelRatio):', Math.log2(window.devicePixelRatio));
        // Если devicePixelRatio больше 1, уменьшаем масштаб страницы, чтобы элементы не выглядели слишком мелкими
        // Применяем зум только для десктопных устройств с большим экраном и точным указателем (мышь)
        const ua = navigator.userAgent;
        const isIpad = /iPad/.test(ua) ||
            (/(Macintosh)/.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ||
            (window.screen.width === 1366  && window.devicePixelRatio === 2) // iPad Pro 12.9" 
            ;

        const isTablet =
            isIpad ||
            /Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(ua);

        const isMobile = /Mobi|Android/i.test(ua);
        const isDesktop = !isTablet && !isMobile;
        if (
            window.innerWidth > 1200 &&
            //window.innerWidth < 1440 &&
            (
                window.matchMedia('(any-pointer: fine)').matches || 
                window.matchMedia('(pointer: fine)').matches // Точный указатель (мышь)
            ) &&
            window.devicePixelRatio > 1 &&
            isDesktop &&
            window.innerWidth !== 1366
        ) {
            // Проверяем, что масштаб браузера 100%
            // Обычно при 100% 1 CSS-пиксель = 1 devicePixelRatio-пиксель
            // Проверим через вычисление:
            const testDiv = document.createElement('div');
            testDiv.style.width = '100px';
            testDiv.style.position = 'absolute';
            testDiv.style.visibility = 'hidden';
            document.body.appendChild(testDiv);
            const cssPixels = testDiv.getBoundingClientRect().width;
            document.body.removeChild(testDiv);

            // Если 100px CSS = 100px device, значит масштаб браузера 100%
            if (Math.abs(cssPixels - 100) < 3) {
                //const ratio = (1 / window.devicePixelRatio) * 1.25; // Немного увеличим, чтобы не было слишком мелко
                const ratio =  window.innerWidth / BASE_WIDTH;
                document.body.style.zoom = ratio.toFixed(2);
            }
        }
        
        if (window.innerWidth > 1500 && //1880
            window.devicePixelRatio === 1
        ) {
            if (document.body) {
                //document.body.style.zoom = 1.25;
                const ratio =  window.innerWidth / BASE_WIDTH;
                document.body.style.zoom = ratio.toFixed(2);
            }
        }
       
    }